export const CURRENT_PRODUCTS_LANGUAGE = 'current-products-language';
